import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=cf08b568&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=cf08b568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf08b568",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf08b568')) {
      api.createRecord('cf08b568', component.options)
    } else {
      api.reload('cf08b568', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=cf08b568&scoped=true&", function () {
      api.rerender('cf08b568', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4SzzCgDbdd4rY/JS/comp/CookieBox.vue"
export default component.exports